module.exports = {"430407001":"人民路街道","430407002":"青山街道","430407003":"潇湘街道","430407004":"五一街道","430407005":"合江街道","430407006":"黄沙湾街道","430407201":"角山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430407.json
// module id = 1835
// module chunks = 0